import React, { useState } from 'react';
import { observer } from 'mobx-react-lite';
import { userInfoStore } from '@pascal/pascal-core/shared/core/store';
import { FreeBetsWrapper, useTranslation } from '@pascal/pascal-core';
import { MobileFooterSection } from '../../components/mobileFooterSection';
import { MobileHeaderSection } from '../../components/mobileHeaderSection';
import { MobileCombinations } from '../../components/mobileCombinations';
import { MobileWinPopUp } from '../../components/mobileWinPopUp';
import { winningStore } from '../../store/winningStore';
import { RoundCards } from '../../components/roundCards';
import { MobileBottomContainer } from '../../containers/mobileBottomContainer';
import { gameStore } from '../../store/gameStore';

export const MobileGameMain = observer(() => {
  const { winningAmount, winCombination } = winningStore;
  const t = useTranslation();
  const [showCardsImages, setShowCardsImages] = useState(true);
  const { currencyCode } = userInfoStore;
  const { isBetsClosed } = gameStore;

  return (
    <div className='tb-game-mobile-wrapper'>
      <FreeBetsWrapper />
      {/*<MobileHeaderSection />*/}
      <div className='tb-game-mobile-content'>
        <div className='tb-g-m-c-wrapper'>
          <div className='tb-g-m-c-top'>
            <div className='tb-g-mob-comb-wrp'>
              {winningAmount && winCombination ? (
                <MobileWinPopUp
                  winCombination={winCombination}
                  winningAmount={winningAmount}
                  currencyCode={currencyCode}
                />
              ) : (
                <MobileCombinations
                  t={t}
                  winCombination={winCombination}
                  showCardsImages={showCardsImages}
                  setShowCardsImages={setShowCardsImages}
                />
              )}
            </div>
          </div>
          <div className='tb-g-m-c-middle'>
            <div className='tb-g-m-c-game-wrp'>
              <div className='tb-game-circle-shadow' />
              <div className='tb-g-m-c-game-inside'>
                <RoundCards />
                {!isBetsClosed && (
                  <div className='place-your-bet-wrp'>
                    <p className='place-your-bet-text'>Place your bets!</p>
                  </div>
                )}
              </div>
            </div>
          </div>
          <MobileBottomContainer />
        </div>
      </div>
      <MobileFooterSection />
    </div>
  );
});
